module.exports = __webpack_public_path__ + "static/media/good-growth-podcast.c072653b.md";